import { gql } from '@apollo/client';

export const REMOVE_FEATURE_FLAGS_FROM_AUTH_DOMAIN = gql`
    mutation removeFeatureFlagsFromAuthDomain($input: RemoveFeatureFlagsFromAuthDomainInput!) {
        system {
            authDomain {
                removeFeatureFlags(input: $input) {
                    companyAlias
                    facilityAlias
                    featureFlags {
                        key
                        isEnabled
                        owner {
                            companyAlias
                            facilityAlias
                        }
                    }
                }
            }
        }
    }
`;
